import { Injectable } from '@angular/core';
import { PAYWALL_CONSTANTS } from '../constants/paywall.constants';

/** Per coach on this device: how often the paywall opened by itself, by source (`…<user id>`). */
const STORAGE_PREFIX = 'saideline.paywall.shown.';

/**
 * Limits how often the paywall opens by itself for a coach: the exit intent only once.
 * Links from mails and ads (`/upgrade`) and a new prompt without sessions left are not limited.
 */
@Injectable({ providedIn: 'root' })
export class PaywallLimitService {
    /** Used when storage is blocked, so the limits still hold until the next reload. */
    private fallbackCounts: Record<string, Record<string, number>> = {};

    /** Whether the paywall may still open for this source and coach. */
    canShow(source: string, userId: string): boolean {
        const limit = PAYWALL_CONSTANTS.LIMITS_PER_COACH[source];
        return limit === undefined || (this.readCounts(userId)[source] ?? 0) < limit;
    }

    /** Counts one opening for this source and coach. */
    markShown(source: string, userId: string): void {
        const counts = this.readCounts(userId);
        counts[source] = (counts[source] ?? 0) + 1;
        this.fallbackCounts[userId] = counts;
        try {
            localStorage.setItem(`${STORAGE_PREFIX}${userId}`, JSON.stringify(counts));
        } catch {
            // Storage blocked: the in-memory counts apply
        }
    }

    private readCounts(userId: string): Record<string, number> {
        try {
            const parsed = JSON.parse(localStorage.getItem(`${STORAGE_PREFIX}${userId}`) ?? 'null');
            return parsed && typeof parsed === 'object' ? parsed : { ...this.fallbackCounts[userId] };
        } catch {
            return { ...this.fallbackCounts[userId] };
        }
    }
}
